import { useEffect, useRef, useState } from 'react';
import { getTimeFromNow } from 'utils/3catinfo/dateHelper';
import { getUrlFriendly } from 'components/3catinfo/Enllac/RouteResolver';
import { useModal } from 'hooks/3catinfo/useModal';
import { dataResources } from 'utils/constants';
import Icona from 'components/3catinfo/ui/Icona';
import Enllac from 'components/3catinfo/Enllac';
import Imatge from 'components/3catinfo/Imatge';
import Boto from 'components/3catinfo/Boto';
import Tooltip from 'components/3catinfo/Tooltip';
import ModalCamera from 'components/3catinfo/ElTemps/ModalCamera';
import moment from 'moment';
import clsx from 'clsx';
import styles from './camera.module.scss';

const CompartirCamara = (props) => {
    const { refButtonCompartir, urlCompartir, nom } = props;
    const [showCompartir, setShowCompartir] = useState(false);
    const [isCopyingLink, setIsCopyingLink] = useState(false);
    const timerCopyLink = useRef(null);
    const secondFocusRef = useRef(null);
    const iframeCode = `<iframe title="Càmera ${nom}" src="${urlCompartir}" frameborder="0" width="600" height="525"></iframe>`;

    const stylesBtnCopiarEnllac = clsx({
        [styles.btn_copia]: true,
        [styles.copiant]: isCopyingLink
    });

    const handleClickCopyLink = () => {
        if (!isCopyingLink) {
            navigator.clipboard.writeText(iframeCode);
            setIsCopyingLink(true);
            timerCopyLink.current = null;
            timerCopyLink.current = setTimeout(() => {
                setIsCopyingLink(false);
            }, 5000);
        }
    };

    useEffect(() => {
        if (showCompartir) {
            secondFocusRef.current.focus();
        }
    }, [showCompartir]);

    useEffect(() => {
        const refButtonCompartirCurrent = refButtonCompartir?.current;
        refButtonCompartirCurrent?.addEventListener('click', () => setShowCompartir(true));

        return () => {
            refButtonCompartirCurrent?.removeEventListener('click', setShowCompartir);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    });

    return showCompartir ? (
        <div className={styles.contentCardComparir}>
            <Boto
                ref={secondFocusRef}
                icona='tanca'
                className={styles.btnTanca}
                estil='transparent'
                fons='dark'
                tag='button'
                isIconaBlanc={true}
                mida='18'
                altIcona='Tancar'
                iconaInline={true}
                onClick={() => setShowCompartir(false)}
            />
            <p>Copia aquest codi per afegir-lo a la teva pàgina web:</p>
            <textarea className={styles.textareaCompartir} value={iframeCode} readOnly tabIndex={-1} />
            <div className={styles.contentBoto}>
                <Boto
                    tag='button'
                    text={isCopyingLink ? 'Codi copiat!' : 'Copia el codi'}
                    estil='ple'
                    fons='fonsContenidorNegre'
                    icona={isCopyingLink ? 'check_no_contorn' : 'enllac'}
                    iconaInline={true}
                    isIconaDreta={false}
                    className={stylesBtnCopiarEnllac}
                    onClick={handleClickCopyLink}
                />
            </div>
        </div>
    ) : (
        <></>
    );
};

const Camera = (props) => {
    const { item, index, items } = props;
    const { setModal, removeModal } = useModal();
    const { id, nom, snapshots, temperatura_actual, humitat, data_creacio } = item;
    const refBotoCompartir = useRef(null);
    const dataActualitzacio = data_creacio ? getTimeFromNow(moment(data_creacio * 1000).format('DD/MM/YYYY HH:mm:ss')) : null;
    const { basePath } = dataResources;

    const getQualitatSenseDades = (qualitat) => (qualitat ?? '').replace('--', 'sense_dades') || 'sense_dades';
    const qualitat_pm10 = getQualitatSenseDades(item.qualitat_pm10);
    const qualitat_no2 = getQualitatSenseDades(item.qualitat_no2);
    const qualitat_o3 = getQualitatSenseDades(item.qualitat_o3);

    const fitxer = snapshots?.[0].fitxer;

    const handleOnClickCamera = () => {
        setModal(<ModalCamera items={items} idSelected={index} onClickClose={removeModal} />, {
            className: styles.cameraModal,
            closeOnClickOutside: true,
            mode: 'full-screen'
        });
    };
    const getAriaLabelNom = () => {
        return 'Imatge de la càmera a ' + nom;
    };
    const getAriaLabelTemperatura = () => {
        return 'Temperatura ' + temperatura_actual + ' graus, Humitat ' + humitat + ' percent';
    };
    const getAriaLabelQualitat = () => {
        return (
            'Qualitat de laire: P M deu ' +
            qualitat_pm10.replace('_', ' ') +
            ',  N O 2  ' +
            qualitat_no2.replace('_', ' ') +
            ',  O 3  ' +
            qualitat_o3.replace('_', ' ')
        );
    };

    const urlCompartir = `https://www.3cat.cat${getUrlFriendly({
        routePath: 'web_3catinfo_el_temps_embed_camera',
        slug: nom,
        id,
        producte: 'web_noticies'
    })}`;

    //const route = { slug: slug || text, type: 'web_actualitat_seccio' };

    return (
        <div className={styles.camera}>
            <section className={styles.cos}>
                <button className={styles.contentImatge} onClick={handleOnClickCamera}>
                    {fitxer && (
                        <div className={styles.imatgeWrapper} aria-label={getAriaLabelNom()}>
                            <Imatge
                                className={styles.imatge}
                                src={`https://statics.3cat.cat${fitxer}`}
                                layout='fill'
                                alt={nom}
                                aria-hidden='true'
                                objectFit='cover'
                            />
                        </div>
                    )}
                    <div className={styles.info}>
                        <div className={styles.dades} aria-label={getAriaLabelTemperatura()}>
                            <span className={styles.temperatura}>{temperatura_actual}º</span>
                            <span className={styles.humitat}>{humitat}% </span>
                        </div>
                        <div className={styles.qualitats} aria-label={getAriaLabelQualitat()}>
                            <Imatge
                                src={`${basePath}/_resources/imatges/3catinfo/cameres/pm10_${qualitat_pm10}.svg`}
                                alt={`Qualitat PM10 ${qualitat_pm10.replace('_', ' ')}`}
                                width='32'
                                height='32'
                            ></Imatge>
                            <Imatge
                                src={`${basePath}/_resources/imatges/3catinfo/cameres/no2_${qualitat_no2}.svg`}
                                alt={`Qualitat NO2 ${qualitat_no2.replace('_', ' ')}`}
                                width='32'
                                height='32'
                            ></Imatge>
                            <Imatge
                                src={`${basePath}/_resources/imatges/3catinfo/cameres/o3_${qualitat_o3}.svg`}
                                alt={`Qualitat O3 ${qualitat_o3.replace('_', ' ')}`}
                                width='32'
                                height='32'
                            ></Imatge>
                        </div>
                    </div>
                </button>

                <div className={styles.contentTitle}>
                    <div className={styles.title} aria-label={nom}>
                        <Enllac
                            route={{
                                type: 'web_3catinfo_el_temps_camera_detall',
                                slug: nom,
                                id,
                                producte: 'web_noticies'
                            }}
                            className={styles.enllacTitol}
                        >
                            {nom}{' '}
                        </Enllac>
                        <Boto
                            ref={refBotoCompartir}
                            icona='enllac'
                            className={styles.botoCompartir}
                            estil='noEstil'
                            tag='button'
                            isIconaBlanc={false}
                            mida='18'
                            altIcona='Insereix càmera a la teva pàgina web'
                            iconaInline={true}
                        />
                        <Tooltip target={refBotoCompartir} content='Insereix càmera' />
                    </div>
                    {dataActualitzacio && (
                        <div className={styles.contentDate}>
                            <Icona className={styles.ico_clock} icona='rellotge' color='blanc' mida='20' alt='Temps' />
                            <span className={styles.date} aria-label={dataActualitzacio}>
                                {dataActualitzacio}
                            </span>
                        </div>
                    )}
                </div>
            </section>
            <CompartirCamara refButtonCompartir={refBotoCompartir} urlCompartir={urlCompartir} nom={nom} />
        </div>
    );
};

export default Camera;
